import { IRecurringExpense } from "@nxs/models";

import dayjs from "dayjs";

export const getApplicableRecurringExpences = (allExpences: IRecurringExpense[], billingCycle: number): IRecurringExpense[] => {
    const billingCycleMonth = dayjs(billingCycle.toString(), 'YYYYMM').startOf('month');
    return allExpences.filter(x => x.subscriptionStarted.isBefore(billingCycleMonth) && (!x.subscriptionEnd || x.subscriptionEnd.isAfter(billingCycleMonth)));
}